export default __webpack_public_path__ + "b92d5aef17ace83504fca9550bfba3fb.png";